import {
  DocumentFieldVerification,
  DocumentVerification,
  ApplicationVerification
} from '../../../services'

import { State } from '../../store.types'
import { GetUpdatedDocumentsProps } from './types'

export const getUpdatedDocuments = ({
  documentHeader,
  rejectionReason,
  documents
}: GetUpdatedDocumentsProps) =>
  documentHeader.documents.reduce<DocumentVerification[]>(
    (accDoc, document) => {
      const currentDocument = documents[document.id]

      if (!currentDocument) {
        return accDoc
      }

      return [
        ...accDoc,
        {
          id: document.id,
          rpsResolution: document.rpsResolution,
          rejectionReason,
          fields: currentDocument.pages.reduce<DocumentFieldVerification[]>(
            (acc, page) => [
              ...acc,
              ...page.fields.map((polygonField) => ({
                id: polygonField.id,
                rpsResolution:
                  currentDocument.fields.find(
                    (field) => polygonField.id === field.id
                  )?.rpsResolution || null
              }))
            ],
            []
          )
        }
      ]
    },
    []
  )

export const selectDocumentResolutionUpdate = (
  state: State
): ApplicationVerification | null => {
  const { documentHeader, documents } = state.document

  if (!documentHeader) {
    return null
  }

  const { id, rpsResolution, rejectionReason } = documentHeader

  return {
    id,
    rpsResolution,
    rejectionReason,
    documents: getUpdatedDocuments({
      documentHeader,
      rejectionReason,
      documents
    })
  }
}
